/* Sticky add-to-cart bundle picker.
   Mirrors the product page "Bundle & save" tiers into the sticky bar: a pill switcher on desktop and a compact dropdown
   that opens upward on phones. Picking a tier in the bar
   selects the same tier in the page (so the quantity and price logic stays in jf-bundle), and changes on the page
   repaint the bar. */
(() => {
  function init() {
    const bar = document.querySelector('.sticky-add-to-cart__bar');
    const bundle = document.querySelector('jf-bundle');
    if (!bar || !bundle) return;
    // Already built for this bar and this bundle: nothing to do. The theme re-renders both on a variant change.
    if (bar.querySelector('.jf-sb__tiers .jf-sb__tier') && bar.querySelector('.jf-sb__pick-top') && bar.jfSbBundle === bundle) { bar.classList.add('jf-sb'); return; }
    bar.querySelectorAll('.jf-sb__tiers, .jf-sb__sum, .jf-sb__pick, .jf-sb__menu').forEach((el) => el.remove());
    if (bar.jfSbObservers) bar.jfSbObservers.forEach((o) => o.disconnect());
    if (bar.jfSbCleanup) bar.jfSbCleanup();
    const tiers = [...bundle.querySelectorAll('.jf-bundle__tier')];
    if (tiers.length < 2) return;
    bar.jfSbBundle = bundle;

    const group = document.createElement('div');
    group.className = 'jf-sb__tiers';
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', 'Choose a bundle');
    const pills = tiers.map((tier) => {
      const pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'jf-sb__tier';
      pill.setAttribute('role', 'radio');
      const name = document.createElement('span');
      // "2 lamps — one for the kids' room" becomes "2 lamps"
      name.textContent = ((tier.querySelector('.jf-bundle__label') || {}).textContent || tier.dataset.qty || '').split(/\s[—–-]\s/)[0].trim();
      pill.append(name);
      const off = parseFloat(tier.dataset.off) || 0;
      if (off) { const em = document.createElement('em'); em.textContent = '-' + off + '%'; pill.append(em); }
      pill.addEventListener('click', () => {
        if (typeof bundle.select === 'function') bundle.select(tier); else tier.click();
        paint();
      });
      group.append(pill);
      return pill;
    });

    // Phone dropdown: a trigger showing the chosen bundle and total, and an upward list of all tiers.
    const uid = 'jf-sb-menu-' + Math.random().toString(36).slice(2, 8);
    const pick = document.createElement('button');
    pick.type = 'button';
    pick.className = 'jf-sb__pick';
    pick.setAttribute('aria-haspopup', 'listbox');
    pick.setAttribute('aria-expanded', 'false');
    pick.setAttribute('aria-controls', uid);
    pick.innerHTML = '<img class="jf-sb__thumb" alt="" width="36" height="36" hidden><span class="jf-sb__pick-text"><span class="jf-sb__pick-top"></span><span class="jf-sb__pick-price"><b></b><s></s></span></span>'
      + '<svg class="jf-sb__chev" viewBox="0 0 16 16" aria-hidden="true"><path d="M4 10l4-4 4 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const menu = document.createElement('ul');
    menu.className = 'jf-sb__menu';
    menu.id = uid;
    menu.setAttribute('role', 'listbox');
    menu.setAttribute('aria-label', 'Choose a bundle');
    const opts = tiers.map((tier, i) => {
      const li = document.createElement('li');
      li.setAttribute('role', 'presentation');
      const opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'jf-sb__opt';
      opt.setAttribute('role', 'option');
      opt.innerHTML = '<span class="jf-sb__dot" aria-hidden="true"></span><span class="jf-sb__opt-name"></span><span class="jf-sb__opt-price"><b></b><small></small></span>';
      opt.querySelector('.jf-sb__opt-name').append(pills[i].firstChild.textContent);
      const off = parseFloat(tier.dataset.off) || 0;
      if (off) { const em = document.createElement('em'); em.textContent = 'Save ' + off + '%'; opt.querySelector('.jf-sb__opt-name').append(em); }
      opt.addEventListener('click', () => { pills[i].click(); open(false); pick.focus(); });
      li.append(opt);
      menu.append(li);
      return opt;
    });
    const open = (on) => {
      menu.classList.toggle('is-open', on);
      pick.setAttribute('aria-expanded', String(on));
      if (on) (opts.find((o) => o.getAttribute('aria-selected') === 'true') || opts[0]).focus({ preventScroll: true });
    };
    pick.addEventListener('click', () => open(!menu.classList.contains('is-open')));
    const onDoc = (e) => { if (!bar.isConnected) return; if (menu.classList.contains('is-open') && !menu.contains(e.target) && !pick.contains(e.target)) open(false); };
    const onKey = (e) => { if (e.key === 'Escape' && menu.classList.contains('is-open')) { open(false); pick.focus(); } };
    document.addEventListener('pointerdown', onDoc);
    document.addEventListener('keydown', onKey);
    bar.jfSbCleanup = () => { document.removeEventListener('pointerdown', onDoc); document.removeEventListener('keydown', onKey); };

    const sum = document.createElement('div');
    sum.className = 'jf-sb__sum';
    sum.innerHTML = '<span class="jf-sb__price"><b></b><s></s></span><span class="jf-sb__meta"></span>';
    const button = bar.querySelector('.sticky-add-to-cart__button');
    bar.insertBefore(pick, button);
    bar.insertBefore(menu, button);
    bar.insertBefore(group, button);
    bar.insertBefore(sum, button);
    bar.classList.add('jf-sb');

    const text = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');
    function paint() {
      // The theme can re-render the bar and strip what we added; rebuild instead of painting stale nodes.
      if (!pick.isConnected || !group.isConnected || !pick.querySelector('.jf-sb__pick-top')) { check(); return; }
      const selected = tiers.find((t) => t.classList.contains('is-selected')) || tiers[0];
      pills.forEach((pill, i) => {
        const on = tiers[i] === selected;
        pill.classList.toggle('is-on', on);
        pill.setAttribute('aria-checked', String(on));
      });
      const set = (el, value) => { if (el.textContent !== value) el.textContent = value; };
      set(sum.querySelector('b'), text(selected.querySelector('[data-price]')));
      set(sum.querySelector('s'), text(selected.querySelector('[data-compare]')));
      const variant = text(bar.querySelector('.sticky-add-to-cart__variant'));
      const each = text(selected.querySelector('[data-each]'));
      set(sum.querySelector('.jf-sb__meta'), [variant, each].filter(Boolean).join(' · '));
      const idx = tiers.indexOf(selected);
      const off = parseFloat(selected.dataset.off) || 0;
      const top = pick.querySelector('.jf-sb__pick-top');
      const topText = pills[idx].firstChild.textContent;
      if (top.dataset.v !== topText + off) {
        top.dataset.v = topText + off;
        top.textContent = topText;
        if (off) { const em = document.createElement('em'); em.textContent = 'Save ' + off + '%'; top.append(em); }
      }
      // Lamp photo from the theme's own sticky image, so it follows the chosen variant.
      const img = bar.querySelector('.sticky-add-to-cart__image img');
      const thumb = pick.querySelector('.jf-sb__thumb');
      const src = img && (img.currentSrc || img.src);
      if (src && thumb.getAttribute('src') !== src) { thumb.src = src; thumb.hidden = false; }
      set(pick.querySelector('b'), text(selected.querySelector('[data-price]')));
      set(pick.querySelector('s'), text(selected.querySelector('[data-compare]')));
      opts.forEach((opt, i) => {
        opt.setAttribute('aria-selected', String(i === idx));
        set(opt.querySelector('.jf-sb__opt-price b'), text(tiers[i].querySelector('[data-price]')));
        set(opt.querySelector('.jf-sb__opt-price small'), text(tiers[i].querySelector('[data-each]')));
      });
    }

    let queued = false;
    const later = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; paint(); }); };
    const watchBundle = new MutationObserver(later);
    watchBundle.observe(bundle, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    const watchVariant = new MutationObserver(later);
    const variant = bar.querySelector('.sticky-add-to-cart__variant');
    if (variant) watchVariant.observe(variant, { subtree: true, childList: true, characterData: true });
    bar.jfSbObservers = [watchBundle, watchVariant];
    paint();
  }

  // Rebuild after the theme swaps the product section (variant change, section re-render).
  let pending = false;
  const check = () => { if (pending) return; pending = true; requestAnimationFrame(() => { pending = false; init(); }); };
  function start() {
    init();
    const root = document.querySelector('main') || document.body;
    new MutationObserver(check).observe(root, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  customElements.whenDefined('jf-bundle').then(check).catch(() => {});
})();

/* Section buttons ("Get yours now", "Get the original") link to #MainContent, which is the top of the gallery on phones,
   about two screens above Add to cart. Send them to the model picker (or the bundle picker) instead. */
document.addEventListener('click', (e) => {
  const link = e.target.closest && e.target.closest('a[href="#MainContent"]');
  if (!link) return;
  const target = document.querySelector('.jf-vc') || document.querySelector('jf-bundle');
  if (!target) return;
  e.preventDefault();
  target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
});
